import Tr from "translations/Translations";

const AnnualReportStatus = {
    DRAFT: "DRAFT",
    SENDING: "SENDING",
    SENT: "SENT",
    APPROVED: "APPROVED",
    APPROVED_MODIFIED: "APPROVED_MODIFIED"
}
export default AnnualReportStatus
export const annualReportStatusTr = (status) => Tr("ezamowienia_mmia_state_" + status)